import { Button } from '@/components/ui'
import TooltipIcon from '../../../assets/icons/tooltip.svg'
import { IColumn } from '../../../core/components/Table'
import { CheckCircleIcon, XCircleIcon } from 'lucide-react'

const checkinColumnSerial = (
  setShowMessageBox: (show: boolean) => void,
  setCancelId: (index: string) => void,
  handleGetCheckinHistory: (ticketCode: string) => void,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Name',
    sortable: true,
    accessor: '',
    render: (row) => `${row.firstName} ${row.lastName}`,
  },
  {
    title: 'Telefon',
    accessor: 'phone',
    sortable: true,
  },
  {
    title: 'Guardian Name',
    accessor: '',
    render: (row) =>
      row.guardianFirstName && row.guardianLastName
        ? `${row.guardianFirstName} ${row.guardianLastName}`
        : '-',
    sortable: true,
  },
  {
    title: 'Guardian Phone',
    accessor: 'guardianPhone',
    render: (row) => (row.guardianPhone ? row.guardianPhone : '-'),
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) => (
      <Button
        onClick={() => {
          setShowMessageBox(true)
          setCancelId(row.id)
        }}
        disabled={!row.cancelable}
        className="btn btn-danger"
        style={{ color: '#FFF', flex: '1', width: '100%' }}
      >
        Cancel Checkin
      </Button>
    ),
  },
  {
    title: 'Action',
    accessor: 'action',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
]

const checkinColumnBarcode = (
  setShowMessageBox: (show: boolean) => void,
  setCancelId: (index: string) => void,
  handleGetCheckinHistory: (ticketCode: string) => void,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Name',
    accessor: '',
    render: (row) => `${row.firstName} ${row.lastName}`,
    sortable: true,
  },
  {
    title: 'Telefon',
    accessor: 'phone',
    sortable: true,
  },
  {
    title: 'Guardian Name',
    accessor: '',
    render: (row) =>
      row.guardianFirstName && row.guardianLastName
        ? `${row.guardianFirstName} ${row.guardianLastName}`
        : '-',
    sortable: true,
  },
  {
    title: 'Guardian Phone',
    accessor: 'guardianPhone',
    render: (row) => (row.guardianPhone ? row.guardianPhone : '-'),
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Action',
    accessor: 'action',
    sortable: true,
    render: (row) => (
      <Button
        variant="destructive"
        onClick={() => {
          setShowMessageBox(true)
          setCancelId(row.id)
        }}
        disabled={!row.cancelable}
        className="flex-1 w-full"
      >
        Cancel Checkin
      </Button>
    ),
  },
]

const checkinColumnEmail = (
  setShowMessageBox: (show: boolean) => void,
  setCancelId: (index: string) => void,
  handleGetCheckinHistory: (ticketCode: string) => void,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Name',
    accessor: '',
    render: (row) => `${row.firstName} ${row.lastName}`,
    sortable: true,
  },
  {
    title: 'Telefon',
    accessor: 'phone',
    sortable: true,
  },
  {
    title: 'Guardian Name',
    accessor: '',
    render: (row) =>
      row.guardianFirstName && row.guardianLastName
        ? `${row.guardianFirstName} ${row.guardianLastName}`
        : '-',
    sortable: true,
  },
  {
    title: 'Guardian Phone',
    accessor: 'guardianPhone',
    render: (row) => (row.guardianPhone ? row.guardianPhone : '-'),
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
  {
    title: 'Action',
    accessor: 'action',
    sortable: true,
    render: (row) => (
      <Button
        onClick={() => {
          setShowMessageBox(true)
          setCancelId(row.id)
        }}
        disabled={!row.cancelable}
        className="flex-1 w-full"
        variant="destructive"
        style={{ color: '#FFF', flex: '1', width: '100%' }}
      >
        Cancel Checkin
      </Button>
    ),
  },
]

const checkinColumnTopup = (
  setShowMessageBox: (show: boolean) => void,
  setCancelId: (id: string) => void,
  handleGetCheckinHistory: (ticketCode: string) => void,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Name',
    accessor: '',
    render: (row) => `${row.firstName} ${row.lastName}`,
    sortable: true,
  },
  {
    title: 'Telefon',
    accessor: 'phone',
    sortable: true,
  },
  {
    title: 'Guardian Name',
    accessor: '',
    render: (row) =>
      row.guardianFirstName && row.guardianLastName
        ? `${row.guardianFirstName} ${row.guardianLastName}`
        : '-',
    sortable: true,
  },
  {
    title: 'Guardian Phone',
    accessor: 'guardianPhone',
    render: (row) => (row.guardianPhone ? row.guardianPhone : '-'),
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
  {
    title: 'Action',
    accessor: 'action',
    sortable: true,
    render: (row) => (
      <Button
        onClick={() => {
          setShowMessageBox(true)
          setCancelId(row.id)
        }}
        disabled={!row.cancelable}
        className="flex-1 w-full"
        variant="destructive"
      >
        Cancel Checkin
      </Button>
    ),
  },
]

export const getCheckinColumn = (
  searchBy: 'serial' | 'barcode' | 'email' | 'topupOrder',
  setShowMessageBox: (show: boolean) => void,
  setCancelId: (index: string) => void,
  handleGetCheckinHistory: (ticketCode: string) => void,
) => {
  switch (searchBy) {
    case 'serial':
      const columnSerial: IColumn[] = checkinColumnSerial(
        setShowMessageBox,
        setCancelId,
        handleGetCheckinHistory,
      )
      return columnSerial
    case 'barcode':
      const columnBarcode: IColumn[] = checkinColumnBarcode(
        setShowMessageBox,
        setCancelId,
        handleGetCheckinHistory,
      )
      return columnBarcode
    case 'email':
      const columnEmail: IColumn[] = checkinColumnEmail(
        setShowMessageBox,
        setCancelId,
        handleGetCheckinHistory,
      )
      return columnEmail
    case 'topupOrder':
      const columnTopUp: IColumn[] = checkinColumnTopup(
        setShowMessageBox,
        setCancelId,
        handleGetCheckinHistory,
      )
      return columnTopUp
    default:
      const column: IColumn[] = checkinColumnSerial(
        setShowMessageBox,
        setCancelId,
        handleGetCheckinHistory,
      )
      return column
  }
}
